import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type DocQuizRevision = {
   doc_quiz_revisionid: number;
   docid: number;
   doctype: 'guide' | 'wiki';
   doc_revisionid: number;
   quizid: number;
   quiz_revisionid: number;
   doc_title: string;
};

export async function createGuideQuizRevision(
   guideid: number,
   quizid: number,
   { ...common }: CommonRequestOptions
): Promise<DocQuizRevision> {
   return makeRequest('post', '/quizzes/attach/guide', {
      ...common,
      body: {
         guideid,
         quizid,
      },
   });
}
